export default {
    data() {
        return {}
    },
    methods: {
        handleCurrentChange(val) {
            this.pageNo = val;
            this.getData();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.pageNo = 1;
            this.getData();
        },
        onCancel() {
            this.$linkBack();
        },
        resetFields(parentRef, childRef = "renderForm") {
            this.$refs[parentRef].$refs[childRef].resetFields()
        },
        onSearch() {
            this.pageNo = 1;
            this.getData();
        },
        //搜索时检验转出的表单
        validateForm(refName) {
            let flag = true;
            this.$refs[refName].$refs.renderForm.validate(
                (valid, errMessage) => {
                    flag = valid;
                    if (!valid) {
                        let message = Object.values(errMessage)[0][0].message;
                        this.$message.error(message);
                    }
                }
            );
            return flag;
        },
    }
};